import { useEffect, type ReactNode } from 'react'
import { setSessionExpiredHandler } from '../services/api-client'

export function SessionExpiryProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    setSessionExpiredHandler(() => {
      const path = window.location.pathname
      if (path === '/auth/logout' || path === '/auth/login' || path === '/auth/error') return
      sessionStorage.setItem('logout_reason', 'session_expired')
      window.location.href = '/auth/logout?reason=session_expired'
    })

    return () => setSessionExpiredHandler(null)
  }, [])

  return <>{children}</>
}
